<div
  #specificContainer
  class="iu-specific-window iu-specific-window-container operation-management-window no-overflow-x tree-maintenance-window"
  [attr.data-cy-specific-window-name]="name">
  <div #dynContainer class="tree-maintenance-header">
    <div class="tree-maintenance-toolbar" role="toolbar">
      <div class="tree-maintenance-toolbar-group">
        <button
          class="p-button tree-maintenance-main-btn"
          data-cy="button-saveTree"
          icon="icon-save3x"
          pButton
          showDelay="250"
          tooltipPosition="top"
          type="button"
          [attr.aria-label]="'menuBarDetails.save' | translate"
          [disabled]="!treeData?.treeNodes"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ 'menuBarDetails.save' | translate }}"
          (mouseup)="$event.button === 0 ? saveTree($event) : null"></button>
        <button
          class="p-button tree-maintenance-main-btn"
          data-cy="button-refreshData"
          icon="icon-refresh3x"
          pButton
          showDelay="250"
          tooltipPosition="top"
          type="button"
          [attr.aria-label]="'menuBarDetails.refresh' | translate"
          [disabled]="!treeData?.treeNodes"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ 'menuBarDetails.refresh' | translate }}"
          (mouseup)="$event.button === 0 ? refresh($event) : null"></button>
        @if (isDirty) {
          <span class="tree-maintenance-dirty" data-cy="tree-maintenance-dirty">
            <i aria-hidden="true" class="fas fa-circle"></i>
            {{ 'tree-maintenance.unsaved-changes' | translate }}
          </span>
        }
      </div>
      <button
        class="p-button tree-maintenance-main-btn"
        data-cy="tree-maintenance-btn-options"
        icon="fas fa-cog"
        pButton
        showDelay="250"
        tooltipPosition="left"
        type="button"
        [attr.aria-label]="'tree-maintenance.options' | translate"
        [hideDelay]="250"
        [life]="3000"
        pTooltip="{{ 'tree-maintenance.options' | translate }}"
        (click)="isSidebarOpen = !isSidebarOpen"></button>
    </div>
    <div class="tree-maintenance-header-row">
      <div class="tree-maintenance-header-lookup">
        <ng-template iuDynamicContainer />
      </div>
      @if (treeID && treeID.id > 0) {
        <div #searchTreeDiv class="tree-maintenance-left-search-zone">
          <iu-input-text-ui
            #searchTreeInputComponent
            [cssGrid]="'p-col-12'"
            [data]="{ columnName: 'searchInTree' }"
            [fieldValue]="treeSearchValue"
            [isStandalone]="true"
            [label]="'tree-maintenance.search-in-tree' | translate"
            (fieldValueChange)="!isLetterByLetterSearch ? searchFromFieldValue($event) : null" />
        </div>
      }
    </div>
  </div>

  <div class="split-view" [style.height]="splitHeight">
    <as-split [gutterSize]="8" [unit]="'percent'">
      <as-split-area [lockSize]="false" [minSize]="25" [size]="50">
        <div class="tree-maintenance-left-container">
          <section class="tree-maintenance-card">
            <header class="tree-maintenance-card-header">
              <span class="tree-maintenance-card-title">{{ 'tree-maintenance.tree-title' | translate }}</span>
              @if (treeData) {
                <span class="tree-maintenance-badge" data-cy="tree-maintenance-node-count">{{ treeNodeCount }}</span>
              }
              <span class="tree-maintenance-spacer"></span>
              <button
                class="p-button tree-maintenance-icon-btn"
                data-cy="tree-maintenance-btn-expand-all"
                icon="fas fa-angle-double-down"
                pButton
                showDelay="250"
                tooltipPosition="top"
                type="button"
                [attr.aria-label]="'tree-maintenance.expand-all' | translate"
                [disabled]="!treeNodes?.length"
                pTooltip="{{ 'tree-maintenance.expand-all' | translate }}"
                (click)="setAllExpanded($event, true)"></button>
              <button
                class="p-button tree-maintenance-icon-btn"
                data-cy="tree-maintenance-btn-collapse-all"
                icon="fas fa-angle-double-up"
                pButton
                showDelay="250"
                tooltipPosition="top"
                type="button"
                [attr.aria-label]="'tree-maintenance.collapse-all' | translate"
                [disabled]="!treeNodes?.length"
                pTooltip="{{ 'tree-maintenance.collapse-all' | translate }}"
                (click)="setAllExpanded($event, false)"></button>
            </header>
            <div class="tree-maintenance-left-tree tree-maintenance-card-body">
              @if (treeNodes && treeNodes.length) {
                <p-tree
                  [draggableNodes]="true"
                  [droppableNodes]="true"
                  [loading]="isTreeLoading"
                  [loadingIcon]="'tree-maintenance-spinner-loading fas fa-circle-notch'"
                  [selectionMode]="'multiple'"
                  [style]="{ overflow: 'auto', height: '100%', width: '100%' }"
                  [trackBy]="trackByFn"
                  [value]="treeNodes"
                  [(selection)]="selectedTreeNodes"
                  (onNodeCollapse)="collapseNode($event)"
                  (onNodeDrop)="dropNode($event)"
                  (onNodeExpand)="expandNode($event)">
                  <ng-template let-node pTemplate="default">
                    <span [class.tree-maintenance-node-summary]="node.data?.isSummary">
                      @for (part of getLabelParts(node.label); track $index) {
                        @if (part.match) {
                          <mark class="tree-maintenance-match">{{ part.text }}</mark>
                        } @else {
                          {{ part.text }}
                        }
                      }
                    </span>
                  </ng-template>
                </p-tree>
              } @else {
                <div class="tree-maintenance-empty">
                  @if (isTreeLoading) {
                    <i aria-hidden="true" class="tree-maintenance-spinner-loading fas fa-circle-notch"></i>
                  } @else if (!treeID || !(treeID.id > 0)) {
                    <i aria-hidden="true" class="fas fa-sitemap"></i>
                    <span>{{ 'tree-maintenance.select-tree' | translate }}</span>
                  } @else if (treeData && treeSearchValue) {
                    <i aria-hidden="true" class="fas fa-search"></i>
                    <span>{{ 'tree-maintenance.no-match' | translate }}</span>
                  } @else if (treeData) {
                    <i aria-hidden="true" class="fas fa-folder-open"></i>
                    <span>{{ 'tree-maintenance.empty-tree' | translate }}</span>
                  }
                </div>
              }
            </div>
          </section>
          <div
            #leftBtnContainer
            class="tree-maintenance-left-btn-container"
            role="toolbar"
            [attr.aria-orientation]="'vertical'">
            <div class="tree-maintenance-btn-group">
              <button
                class="p-button tree-maintenance-left-btn"
                data-cy="tree-maintenance-btn-left"
                icon="fas fa-angle-left"
                pButton
                showDelay="250"
                tooltipPosition="left"
                type="button"
                [attr.aria-label]="'tree-maintenance.add-to-tree' | translate"
                [disabled]="!selectedLines?.length"
                pTooltip="{{ 'tree-maintenance.add-to-tree' | translate }}"
                (click)="addInTree($event)"></button>
              <button
                class="p-button tree-maintenance-left-btn"
                data-cy="tree-maintenance-btn-right"
                icon="fas fa-angle-right"
                pButton
                showDelay="250"
                tooltipPosition="left"
                type="button"
                [attr.aria-label]="'tree-maintenance.remove-from-tree' | translate"
                [disabled]="!selectedTreeNodes?.length"
                pTooltip="{{ 'tree-maintenance.remove-from-tree' | translate }}"
                (click)="deleteFromTree($event)"></button>
            </div>
            <div class="tree-maintenance-btn-group">
              <button
                class="p-button tree-maintenance-left-btn"
                data-cy="tree-maintenance-btn-double-up"
                icon="fas fa-angle-double-up"
                pButton
                showDelay="250"
                tooltipPosition="left"
                type="button"
                [attr.aria-label]="'tree-maintenance.move-first' | translate"
                [disabled]="!selectedTreeNodes?.length"
                pTooltip="{{ 'tree-maintenance.move-first' | translate }}"
                (click)="stepUp($event, '*')"></button>
              <button
                class="p-button tree-maintenance-left-btn"
                data-cy="tree-maintenance-btn-up"
                icon="fas fa-angle-up"
                pButton
                showDelay="250"
                tooltipPosition="left"
                type="button"
                [attr.aria-label]="'tree-maintenance.move-up' | translate"
                [disabled]="isMovementDisabled || !selectedTreeNodes?.length"
                pTooltip="{{ 'tree-maintenance.move-up' | translate }}"
                (click)="stepUp($event)"></button>
              <button
                class="p-button tree-maintenance-left-btn"
                data-cy="tree-maintenance-btn-down"
                icon="fas fa-angle-down"
                pButton
                showDelay="250"
                tooltipPosition="left"
                type="button"
                [attr.aria-label]="'tree-maintenance.move-down' | translate"
                [disabled]="isMovementDisabled || !selectedTreeNodes?.length"
                pTooltip="{{ 'tree-maintenance.move-down' | translate }}"
                (click)="stepDown($event)"></button>
              <button
                class="p-button tree-maintenance-left-btn"
                data-cy="tree-maintenance-btn-double-down"
                icon="fas fa-angle-double-down"
                pButton
                showDelay="250"
                tooltipPosition="left"
                type="button"
                [attr.aria-label]="'tree-maintenance.move-last' | translate"
                [disabled]="!selectedTreeNodes?.length"
                pTooltip="{{ 'tree-maintenance.move-last' | translate }}"
                (click)="stepDown($event, '*')"></button>
            </div>
            <div class="tree-maintenance-btn-group">
              <button
                class="p-button tree-maintenance-left-btn"
                data-cy="tree-maintenance-btn-step-in"
                icon="fas fa-indent"
                pButton
                showDelay="250"
                tooltipPosition="left"
                type="button"
                [attr.aria-label]="'tree-maintenance.indent' | translate"
                [disabled]="isMovementDisabled || !selectedTreeNodes?.length"
                pTooltip="{{ 'tree-maintenance.indent' | translate }}"
                (click)="stepIn($event)"></button>
              <button
                class="p-button tree-maintenance-left-btn"
                data-cy="tree-maintenance-btn-step-out"
                icon="fas fa-outdent"
                pButton
                showDelay="250"
                tooltipPosition="left"
                type="button"
                [attr.aria-label]="'tree-maintenance.outdent' | translate"
                [disabled]="isMovementDisabled || !selectedTreeNodes?.length"
                pTooltip="{{ 'tree-maintenance.outdent' | translate }}"
                (click)="stepOut($event)"></button>
            </div>
          </div>
        </div>
      </as-split-area>
      <as-split-area [lockSize]="false" [minSize]="25" [size]="50">
        <section class="tree-maintenance-card tree-maintenance-right-container">
          <header class="tree-maintenance-card-header">
            <span class="tree-maintenance-card-title">{{ 'tree-maintenance.grid-title' | translate }}</span>
            @if (colTableHeaders && colTableHeaders.length && gridRowCount >= 0) {
              <span class="tree-maintenance-badge" data-cy="tree-maintenance-grid-count">{{ gridRowCount }}</span>
            }
            <span class="tree-maintenance-spacer"></span>
            @if (colTableHeaders && colTableHeaders.length) {
              <span class="tree-maintenance-hint">{{ 'tree-maintenance.grid-hint' | translate }}</span>
            }
          </header>
          @if (colTableHeaders && colTableHeaders.length) {
            <div #searchGridDiv class="tree-maintenance-right-search-zone">
              <div class="tree-maintenance-right-search-field">
                <iu-input-text-ui
                  [cssGrid]="'p-col-12'"
                  [data]="{ columnName: 'searchInGrid' }"
                  [fieldValue]="gridSearchValue"
                  [isStandalone]="true"
                  [label]="'tree-maintenance.search-in-grid' | translate"
                  (fieldValueChange)="searchInGrid($event)" />
              </div>
              <div class="tree-maintenance-right-warning">
                <i
                  aria-hidden="true"
                  class="fas fa-info-circle"
                  tooltipPosition="bottom"
                  [hideDelay]="250"
                  [life]="3000"
                  pTooltip="{{ 'tree-maintenance.warning-search' | translate }}"></i>
              </div>
            </div>
            <div class="tree-maintenance-card-body tree-maintenance-grid-body">
              <iu-grid-tab-infinity-scroll-ui
                #gridTab
                data-cy-grid-tablename="tree-maintenance-search-grid"
                [data]="{
                  frameworkComponents,
                  columnsTableHeader: colTableHeaders,
                  AD_FormDetail_ID: undefined,
                  searchColumns,
                }"
                [forcePaginationAutoPageSize]="true"
                [getDataGrid]="getDataGrid"
                [isSearch]="true"
                [overridedTableHeight]="true"
                [parentFormID]="fields[0]?.formDetailId"
                [rowClassRules]="rowClassRules"
                [tableHeight]="'calc(100% - 5px)'"
                [windowType]="IupicsMenuType.FORM"
                (multiSelectEmitter)="onSelectOnGrid($event)" />
            </div>
          } @else {
            <div class="tree-maintenance-card-body tree-maintenance-empty">
              @if (treeID && treeID.id > 0) {
                <i aria-hidden="true" class="tree-maintenance-spinner-loading fas fa-circle-notch"></i>
              } @else {
                <i aria-hidden="true" class="fas fa-th-list"></i>
                <span>{{ 'tree-maintenance.select-tree' | translate }}</span>
              }
            </div>
          }
        </section>
      </as-split-area>
    </as-split>
  </div>

  <p-sidebar
    position="right"
    styleClass="p-sidebar-md optionalFilterPanel"
    [baseZIndex]="0"
    [(visible)]="isSidebarOpen">
    <h1 class="iu-notification-center-title">
      {{ 'specificWindow.optionalFilters' | translate }}
    </h1>
    <div class="optionalFields">
      <ng-template #optional />
      <div>
        <iu-input-switch-ui
          [fieldValue]="isLetterByLetterSearch ? 'Y' : 'N'"
          [isStandalone]="true"
          [label]="'tree-maintenance.letter-by-letter' | translate"
          (fieldValueModified)="setConfig('isLetterByLetterSearch', $event)" />
      </div>
    </div>
  </p-sidebar>
</div>

<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    [angularStyle]="customFormModalBodyCss"
    [isModalDisplay]="displayFormUI"
    [title]="specificWindowTitle"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false, sourceComponent: this }})">
    <ng-template #vcrSpecific />
  </iu-modal-ui>
</div>
